import './scripts/show-more-less.jsx'

function screenWidth()
{
    return window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;
}

document.addEventListener("DOMContentLoaded", function () {
    // Меню
    const qrBtnIos = document.querySelectorAll(".qrBtn.ios");
    const qrBtnAndroid = document.querySelectorAll(".qrBtn.android");
    const mainMenuIos = document.querySelector(".mainQr.ios");
    const mainMenuAndroid = document.querySelector(".mainQr.android");
    const mainWrapperMenu = document.querySelector(".mainMenuWrapper");
    const body = document.querySelector("body");
    const closebtn = document.querySelector(".mainQr_close");

    const applyFormPopup = document.querySelector(".apply-form-popup");
    const carousel = document.querySelector('.logo-carousel');
    const applyToJoinPopup = document.querySelector(".apply-to-join-popup");
    const applyButton = document.querySelector('.apply-form-popup form .form_btn');

    const iosqr = document.querySelector('.iosqr');
    const androidqr = document.querySelector('.androidqr');

    const qrBtnIosPopup = document.querySelector(".scan-qrcode-popup .qrBtn.ios");
    const qrBtnAndroidPopup = document.querySelector(".scan-qrcode-popup .qrBtn.android");

    iosqr?.addEventListener('click', () => {
        if (qrBtnIosPopup.classList.contains('active')) {
            return;
        } else {
            qrBtnIosPopup.classList.add('active');
            qrBtnAndroidPopup.classList.remove('active');
        }
    });

    androidqr?.addEventListener('click', () => {
        if (qrBtnAndroidPopup.classList.contains('active')) {
            return;
        }
        else {
            qrBtnAndroidPopup.classList.add('active');
            qrBtnIosPopup.classList.remove('active');
        }
    });


    const scanQrcodePopup = document.querySelector('.scan-qrcode-popup');

    qrBtnIos.forEach((item) => {
        item.addEventListener("click", function (e) {
            if (screenWidth() < 576) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            mainMenuIos.classList.add("act");
            body.style.overflow = "hidden";
            mainWrapperMenu.classList.add("active");
            closebtn.classList.add("active");
        });
    });

    if (window.showForm) {
        applyToJoinPopup.classList.add("act");
        carousel.classList.add("act");
        body.style.overflow = "hidden";
        mainWrapperMenu.classList.add("active");
    } else if (applyFormPopup) {
        if (window.location.search.indexOf('show=true') === -1) {
            applyFormPopup.classList.add("act");
            carousel.classList.add("act");
            body.style.overflow = "hidden";
            mainWrapperMenu.classList.add("active");
        }
    }

    qrBtnAndroid.forEach((item) => {
        item.addEventListener("click", function (e) {
            if (screenWidth() < 576) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            mainMenuAndroid.classList.add("act");
            body.style.overflow = "hidden";
            mainWrapperMenu.classList.add("active");
            closebtn.classList.add("active");
        });
    });

    closebtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        mainMenuIos.classList.remove("act");
        mainMenuAndroid.classList.remove("act");
        mainWrapperMenu.classList.remove("active");
        body.style.overflow = "visible";
        closebtn.classList.remove("active");
    });

    // Опередяем платформу
    const iosBtn = document.querySelectorAll(".ios");
    const androidBtn = document.querySelectorAll(".android");

    function getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            androidBtn.forEach((item) => {
                item.style.display = "none";
            });
        }
        if (/android/i.test(userAgent)) {
            iosBtn.forEach((item) => {
                item.style.display = "none";
            });
        }
        return "unknown";
    }

    function checkScreenWidthAndExecute() {
        if (window.innerWidth < 576) {
            getMobileOperatingSystem();
        }
    }

    checkScreenWidthAndExecute();

    if (document.querySelector(".wrapper__qr")) {
        const wrapperQr = document.querySelectorAll(".wrapper__qr");
        wrapperQr.forEach((item) => {
            item.addEventListener("click", () => {
                if (item.classList.contains("active")) {
                    return;
                } else {
                    wrapperQr.forEach((el) => {
                        el.classList.remove("active");
                    });
                    item.classList.add("active");
                }
            });
        });
    }

    if (document.querySelector(".form_btn")) {
        const formBtns = document.querySelectorAll(".form_btn");
        // const formBtn = document.querySelector(".form_btn");
        // const wrapperFirstPage = document.querySelector(".main__wrapper_pc");
        // const wrappeSecondPage = document.querySelector(".step2");
        //
        // const lastText = document.querySelector(".mob__text");


        formBtns.forEach((formBtn) => {
            const form = formBtn.closest("form");
            const phoneInput = form.querySelector(".phone_input");
            const phoneInputs = document.querySelectorAll(".phone_input");
            const typeInput = form.querySelector(".type_input");
            const titleSlugInput = form.querySelector(".title_slug_input");
            const idInput = form.querySelector(".id_input");

            phoneInput.addEventListener('input', handleInput, false);
            phoneInput.addEventListener('input', function () {
                hideError();
            }, false);

            formBtn.addEventListener("click", (e) => {

            // phoneInputs.forEach((input) => {
            //     input.addEventListener('input', handleInput, false);
            //     input.addEventListener('input', function () {
            //         hideError();
            //     }, false);
            // });

            function showError(text) {
                const error = form.querySelector(".form__input .error");
                error.classList.add("active");
                error.classList.remove("blink");
                setTimeout(() => {
                    error.classList.add("blink");
                }, 0);
                error.innerHTML = text;
            }

            function hideError() {
                const error = form.querySelector(".form__input .error");
                error.classList.remove("active");
                error.classList.remove("blink");
            }

            e.preventDefault();

            var phone = clearPhone(phoneInput.value);
            if (!phone) {
                showError("Please enter your phone number");
                return;
            }
            if (phone.length < 10) {
                showError("Please enter a valid phone number");
                return;
            }

            const urlParams = new URLSearchParams(window.location.search);
            const id = idInput.value || urlParams.get('id') || 0;
            var type = typeInput.value || 0;
            const title_slug = titleSlugInput.value || '';

            sendApplyForm(id, phone, type, title_slug).then((response) => {
                if (response.status !== 'success') {
                    showError("Form submission error. Please try again.");
                    return;
                }

                const timeout = setTimeout(() => {
                    window.location.href = '/job/success';
                }, 1300);

                gtag('event', 'apply_form_submit', {
                    listing_id: id,
                    listing_type: type,
                    listing_title_slug: title_slug,
                    event_callback: function() {
                        // wrapperFirstPage.style.display = "none";
                        // wrappeSecondPage.style.display = "block";
                        // lastText.style.display = "none";
                        if (window.showForm) {
                            applyToJoinPopup.classList.remove("act");
                            scanQrcodePopup.classList.add("act");
                        } else if (response.redirect) {
                            window.location.href = response.redirect;
                        } else {
                            window.location.href = '/job/success';
                        }
                        clearTimeout(timeout);
                    },
                    event_timeout: 1000
                });
            }).catch((error) => {

            });

        });
    })
    }
});

function sendApplyForm(id, phone, type = 0, title_slug = '') {
    return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append("phone", phone);
        formData.append("type", String(type));
        formData.append("title_slug", String(title_slug));

        fetch("/api/apply-job/" + (id || 0), {
            method: "POST",
            body: formData,
        }).then((response) => {
            return response.json();
        })
        .then((data) => {
            resolve(data);
        })
        .catch((error) => {
            reject(error);
        });
    });

}

function handleInput (e) {
    console.log('input event fired', e.target.value);
    e.target.value = phoneMask(e.target.value)
}

function phoneMask(value) {
  const digits = value.replace(/\D/g, '').substring(0, 10);
  const parts = [];

  if (digits.length > 0) parts.push('(' + digits.substring(0, 3));
  if (digits.length >= 4) parts.push(') ' + digits.substring(3, 6));
  if (digits.length >= 7) parts.push('-' + digits.substring(6, 10));

  return parts.join('');
}

function clearPhone (phone) {
    return phone.replace(/\D/g, '');
}


const customSelect = document.querySelector('.custom-select');
const selectDisplay = document.querySelector('.select-display');
const customSelectOptions = document.querySelectorAll('.custom-select li');

if(customSelect) {
// Toggle dropdown on click
    selectDisplay.addEventListener('click', () => {
        customSelect.classList.toggle('active');
    });

// Handle option selection
    customSelectOptions.forEach(option => {
        option.addEventListener('click', (e) => {
            // selectDisplay.textContent = e.target.textContent;
            customSelect.classList.remove('active');

            // Remove previous selection
            options.forEach(opt => opt.classList.remove('selected'));
            // Mark the selected option
            e.target.classList.add('selected');
        });
    });
}
